
import { Routes } from '@angular/router';
import { AuthGuard, LoginSuccessGuard } from '@uoa/auth';


export const routes: Routes = [
  {
    path: 'error/:errorCode',
    loadChildren: () => import('./app/error-routing/error.routes').then((m) => m.errorRoutes),
  },
  {
    path: 'home',
    canActivate: [LoginSuccessGuard],
    loadComponent: () => import('./app/pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./app/pages/protected/protected.routes').then((m) => m.protectedRoutes),
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
